const MuiTypography = {
  htmlFontSize: 16,
  fontFamily: ['"Pretendard"', '"Noto Sans KR"', 'Roboto', '"Helvetica"', 'Arial', 'sans-serif'].join(','),
  s48w900: {
    fontSize: 48,
    fontWeight: 900,
  },
  s40w900: {
    fontSize: 40,
    fontWeight: 900,
  },
  s40w400: {
    fontSize: 40,
    fontWeight: 400,
  },
  s36w800: {
    fontSize: 36,
    fontWeight: 800,
  },
  s36w400: {
    fontSize: 36,
    fontWeight: 400,
  },
  s32w400: {
    fontSize: 32,
    fontWeight: 400,
  },
  s24w800: {
    fontSize: 24,
    fontWeight: 800,
  },
  s24w400: {
    fontSize: 24,
    fontWeight: 400,
  },
  s22w700: {
    fontSize: 22,
    fontWeight: 700,
  },
  s20w700: {
    fontSize: 20,
    fontWeight: 700,
  },
  s20w600: {
    fontSize: 20,
    fontWeight: 600,
  },
  s20w400: {
    fontSize: 20,
    fontWeight: 400,
  },
  s18w800: {
    fontSize: 18,
    fontWeight: 800,
  },
  s18w600: {
    fontSize: 18,
    fontWeight: 600,
  },
  s17w400: {
    fontSize: 17,
    fontWeight: 400,
  },
  s16w800: {
    fontSize: 16,
    fontWeight: 800,
  },
  s15w600: {
    fontSize: 15,
    fontWeight: 600,
  },
  s15w500: {
    fontSize: 15,
    fontWeight: 500,
  },
  s15w400: {
    fontSize: 15,
    fontWeight: 400,
  },
  s14w500: {
    fontSize: 14,
    fontWeight: 500,
  },
  s14w400: {
    fontSize: 14,
    fontWeight: 400,
  },
  s14w600: {
    fontSize: 14,
    fontWeight: 600,
  },
  s13w800: {
    fontSize: 13,
    fontWeight: 800,
  },
  s13w500: {
    fontSize: 13,
    fontWeight: 500,
  },
  s13w400: {
    fontSize: 13,
    fontWeight: 400,
  },
  s12w500: {
    fontSize: 12,
    fontWeight: 500,
  },
  s12w400: {
    fontSize: 12,
    fontWeight: 400,
  },
  h1: {
    marginTop: 0,
    fontWeight: 500,
    fontSize: 'calc(1.3625rem + 1.35vw)',
    lineHeight: 1.1,
    color: '#2a2a2a',
    '@media (min-width: 1200px)': {
      fontSize: '2.375rem',
    },
  },
  h2: {
    marginTop: 0,
    fontWeight: 500,
    fontSize: 'calc(1.325rem + 0.9vw)',
    lineHeight: 1.1,
    color: '#2a2a2a',
    '@media (min-width: 1200px)': {
      fontSize: '2rem',
    },
  },
  h3: {
    marginTop: 0,
    fontWeight: 500,
    fontSize: 'calc(1.2875rem + 0.45vw)',
    lineHeight: 1.1,
    color: '#2a2a2a',
    '@media (min-width: 1200px)': {
      fontSize: '1.625rem',
    },
  },
  h4: {
    marginTop: 0,
    fontWeight: 500,
    fontSize: 'calc(1.25rem + 0.15vw)',
    lineHeight: 1.1,
    color: '#2a2a2a',
    '@media (min-width: 1200px)': {
      fontSize: '1.375rem',
    },
  },
  h5: {
    marginTop: 0,
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.1,
    color: '#2a2a2a',
  },
  h6: {
    marginTop: 0,
    fontWeight: 500,
    fontSize: '0.8125rem',
    lineHeight: 1.1,
    color: '#2a2a2a',
  },
  caption: {
    paddingTop: '0.625rem',
    paddingBottom: '0.625rem',
    textAlign: 'left',
    color: '#a1acb8',
  },
  body1: {
    fontSize: '0.875rem',
    lineHeight: 1.1,
  },
  body2: {
    fontSize: '0.75rem',
    lineHeight: 1.1,
  },
  subtitle1: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.1,
  },
  subtitle2: {
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.1,
  },
  overline: {
    lineHeight: 1.1,
  },
} as const;

type CustomTypography = {
  [Key in keyof typeof MuiTypography]: (typeof MuiTypography)[Key];
};

declare module '@mui/material/styles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface TypographyVariants extends CustomTypography {}
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface TypographyVariantsOptions extends CustomTypography {}
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    [key: string]: true;
  }
}

export default MuiTypography;
